import React from 'react';
import {connect} from 'react-redux';
// Components
import Anchor from 'Components/common/Anchor';
import copy from 'copy-to-clipboard';
import {openNotification} from 'Actions/notification';

// Actions
import {T} from 'Actions/translate';
import {yourMassageRead} from 'Actions/host';
class YourMessageItem extends React.Component {
    state = {
        readID: null,
    };

    copyContent = (e, text) => {
        const {item} = this.props;
        if (item.messageMode === 'TASK') {
            if (e && e.stopPropagation) {
                e.stopPropagation();
            } else {
                window.e.cancelBubble = true;
            }
        }
        copy(text);
        this.props.openNotification(T('notification_copy_success'), 'success');
    };

    phoneClick = (e) => {
        e.stopPropagation();
    };

    signRead = (e, id) => {
        const {item} = this.props;
        if (item.messageMode === 'TASK') {
            if (e && e.stopPropagation) {
                e.stopPropagation();
            } else {
                window.e.cancelBubble = true;
            }
        }
        this.props.yourMassageRead(id).then((res) => {
            if (res && res.status === 'success') {
                this.props.markRaad();
                this.props.openNotification(
                    T('your_message_marked_read'),
                    'success',
                );
            }
        });
    };

    render() {
        const {item, userId} = this.props;
        return (
            <Anchor
                className="your_message_item"
                onClickOfSingleTap={this.props.chooseItem}>
                <div className="your_message_item_info">
                    <h2>
                        {item.hasOwnProperty('messageMode') &&
                        item.messageMode === 'TASK'
                            ? item.messageId
                            : item.messageKey}{' '}
                        <span
                            className="your_message_item_info_copy"
                            onTouchStart={this.phoneClick}
                            onClick={(event) =>
                                this.copyContent(
                                    event,
                                    item.hasOwnProperty('messageMode') &&
                                        item.messageMode === 'TASK'
                                        ? item.messageId
                                        : item.messageKey,
                                )
                            }>
                            {T('copy')}
                        </span>
                    </h2>
                    <p className="your_message_item_info_time">
                        {item.createTime}
                    </p>
                </div>
                <div className="your_message_item_content">
                    <p className="message-second-row">
                        <div className="your_message_item_content_from">
                            {item.fromUserName !== '系统提示'
                                ? T('host_message_list_admin')
                                : ''}
                            {item.fromUserName}
                        </div>{' '}
                        To:{' '}
                        <div className="your_message_item_content_to">
                            {item.toUserNameList && item.toUserNameList.length
                                ? item.toUserNameList.join('，')
                                : ''}
                        </div>
                    </p>

                    {item.hasOwnProperty('messageMode') &&
                    item.messageMode === 'TASK' &&
                    item.remark ? (
                        <p className="message-stAlpname">
                            {T('task_details_subject')}: {item.remark}
                        </p>
                    ) : null}

                    {item.messageMode === 'TASK' &&
                    item.category &&
                    item.subcategories &&
                    item.subcategories.length > 0 ? (
                        <p className="message-category-row">
                            <div className="message-category-container">
                                {T('host_message_list_task_category')}
                                {item.category}
                            </div>

                            <div className="message-subcategory-container">
                                {T('host_message_list_task_subcategory')}
                                {item.subcategories && item.subcategories.length
                                    ? item.subcategories.join('，')
                                    : ''}
                            </div>
                        </p>
                    ) : null}

                    <p className="your_message_item_content_item">
                        {item.content}
                    </p>
                </div>

                {userId === item.toUserId ? (
                    <div className="your_message_item_sign">
                        {item.status === 'READ' ? (
                            <span className="your_message_item_sign_read">
                                {T('your_message_read')}
                            </span>
                        ) : (
                            <span
                                onClick={(event) =>
                                    this.signRead(event, item.id)
                                }
                                onTouchStart={this.phoneClick}
                                className="your_message_item_unread">
                                {T('your_message_sign_read')}
                            </span>
                        )}
                    </div>
                ) : item.status === 'READ' ? (
                    <div className="your_message_item_sign">
                        <span className="your_message_item_sign_read">
                            {T('your_message_read')}
                        </span>
                    </div>
                ) : null}
            </Anchor>
        );
    }
}

const mapStateToProps = (state) => {
    const {localData} = state;
    return {
        localData,
    };
};

const mapDispatchToProps = {
    openNotification,
    yourMassageRead,
};
export default connect(mapStateToProps, mapDispatchToProps)(YourMessageItem);
